import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16429fa3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LeadId" }
const _hoisted_2 = {
  key: 1,
  class: "LeadId__content"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка жалобы...", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_9 = { class: "content__block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content__block__title" }, "Оcновная информация:", -1))
const _hoisted_11 = { class: "content__block__main" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Имя:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Компания:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер телефона:", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Источник:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "e-mail:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата:", -1))
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Комментарий:", -1))
const _hoisted_20 = { class: "border rounded p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.state.is_loading,
          text: "При получении лида произошла ошибка",
          onRefresh: _ctx.loadLead
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ]))
            : (_ctx.state.lead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_page_title, {
                        title: `ЛИД (ID: ${_ctx.state.lead.id})`
                      }, null, 8, ["title"])
                    ]),
                    _createVNode(_component_the_button, {
                      class: "second small text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" Назад ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", null, [
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.name), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.companyName || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.phoneNumber || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.source || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.email || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.lead.createdAt || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.state.lead.comment || '-'), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
  ]))
}